import { COMPONENT_EVENT_CAPABILITIES_V1 } from "./generated/component-event-capabilities.v1"

export { COMPONENT_EVENT_CAPABILITIES_V1 }

export type ComponentEventCapabilityHostKind =
  | "native-control"
  | "composite-proxy"
  | "non-interactive"

export type ComponentEventCapabilityFocusStrategy =
  | "focus-visible"
  | "focus-within"
  | "none"

export interface ComponentEventCapability {
  readonly events: readonly string[]
  readonly primaryEvent: string | null
  readonly hostKind: ComponentEventCapabilityHostKind
  readonly focusStrategy: ComponentEventCapabilityFocusStrategy
  readonly evidence: readonly {
    readonly sourceFile: string
    readonly sourceSymbol: string
  }[]
}

const COMPONENTS = COMPONENT_EVENT_CAPABILITIES_V1.components as Record<
  string,
  ComponentEventCapability
>

export const COMPONENT_EVENT_CAPABILITY_COMPONENT_TYPES = Object.freeze(
  Object.keys(COMPONENTS),
)

export const COMPONENT_EVENT_CAPABILITY_EVENTS = Object.freeze(
  Object.fromEntries(
    COMPONENT_EVENT_CAPABILITY_COMPONENT_TYPES.map((componentType) => [
      componentType,
      Object.freeze([...COMPONENTS[componentType].events]),
    ]),
  ),
) as Readonly<Record<string, readonly string[]>>

export function getComponentEventCapability(
  componentType: string,
): ComponentEventCapability | undefined {
  return COMPONENTS[componentType]
}
